(() => {
  const accordions = new WeakMap();
  function accordion(details) {
    const summary = details.querySelector('summary');
    let animation;
    let expanded = details.open;
    function setExpanded(open) {
      expanded = open;
      const start = details.getBoundingClientRect().height;
      animation?.cancel();
      animation = null;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        details.open = open;
        return;
      }
      details.open = true;
      const end = open ? details.scrollHeight : summary.getBoundingClientRect().height;
      animation = details.animate({height: [start + 'px', end + 'px']}, {duration: 400, easing: 'cubic-bezier(.16,1,.3,1)'});
      animation.onfinish = () => { details.open = open; animation = null; };
    }
    accordions.set(details, () => { if (expanded) setExpanded(false); });
    summary.addEventListener('click', event => {
      event.preventDefault();
      if (!expanded) {
        const group = details.closest('ll-accordion, ll-article-accordion');
        group.querySelectorAll('.blDisc, .llAccordionItem').forEach(other => {
          if (other !== details) accordions.get(other)?.();
        });
      }
      setExpanded(!expanded);
    });
  }

  class Accordion extends HTMLElement {
    connectedCallback() {
      this.initialized ||= new WeakSet();
      const initialize = () => this.querySelectorAll('.blDisc, .llAccordionItem').forEach(details => {
        if (this.initialized.has(details)) return;
        this.initialized.add(details);
        accordion(details);
      });
      initialize();
      this.observer = new MutationObserver(initialize);
      this.observer.observe(this, {childList:true,subtree:true});
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  if (!customElements.get('ll-accordion')) customElements.define('ll-accordion', Accordion);
  if (!customElements.get('ll-article-accordion')) customElements.define('ll-article-accordion', class extends Accordion {});
})();
